import { HTTPService } from "../core/util/httpManager.js";
import { Stock } from "./stocksGrid.js";
import { Grid } from "../core/components/grid.js";
import { Helper } from "../core/util/helper.js";
import { General } from "../../siteManagement/general.js";
import { Config } from "../core/config/config.js";
import React from "react";

export const OpenUsagesGrid = async (stock: Stock, title: string) => {
    const [data] = await Promise.all([
        HTTPService.post("Stock/GetUsages", {
            ArtNr: stock.ArtNr,
            ChargenNr: stock.ChargenNr,
            SerienNr: stock.SerienNr,
            LagerplatzId: stock.StorageSpaceId
        })
    ]);
    const sheet = General.Sheet.Manager.createSheet();
    const props: UsagesGridProps = {
        data: data,
        stock: stock
    }
    sheet.show(() => {
        sheet.mountContent(UsagesGrid, props);
        sheet.setTitle(title);
    });
}

interface GridItem {
    Type: number;
    Amount: number;
    Name: string;
    Pk: string;
    CreatedOn: string;
}
interface UsagesGridProps {
    data: GridItem[];
    stock: Stock;
}
class UsagesGrid extends React.Component<UsagesGridProps, any>{
    private gridOptions: kendo.ui.GridOptions;
    private PROJECT = 0;
    private SERVICE_REPORT = 1;
    private ASSIGNMENT = 2;
    constructor(props: UsagesGridProps) {
        super(props)
        this.init();
    }

    private init = () => {
        const amountTemplate = (amount: number, text: string = "") => {
            return `<div style='width:100%; display: flex; justify-content: space-between;'><div style='flex: 1'>${text}</div><div>${amount}</div></div>`
        }
        this.gridOptions = {
            dataSource: {
                group: {
                    dir: "asc",
                    field: "Type"
                }
            },
            sortable: true,
            pageable: false,
            groupable: {
                showFooter: true
            },
            selectable: true,
            resizable: true,
            scrollable: true,
            filterable: {
                extra: false
            },
            editable: false,
            columns: [
                {
                    field: "Type",
                    title: Helper.getTranslation("Field.Vorgang.typ"),
                    template: (dataItem: GridItem) => {
                        switch (dataItem.Type) {
                            case this.PROJECT:
                                return Helper.getTranslation("Statistik.IN_OVERVIEW_EVENTS.Project")
                            case this.SERVICE_REPORT:
                                return Helper.getTranslation("WebSMS.ReportMetadata.TargetEntity.ServiceReport")
                            case this.ASSIGNMENT:
                                return Helper.getTranslation("BrowserTitle.Assigment.Available")
                            default:
                                return "n/a"
                        }
                    },
                    groupHeaderTemplate: (data: KendoGroupingData) => {
                        switch (data.value) {
                            case this.PROJECT:
                                return Helper.getTranslation("WebSMS.DataExchangeModule.EditTemplate.Projects")
                            case this.SERVICE_REPORT:
                                return Helper.getTranslation("WebSMS.DataExchangeModule.EditTemplate.Reports")
                            case this.ASSIGNMENT:
                                return Helper.getTranslation("Field.Enum.LinkedType.Assignments")
                            default:
                                return "n/a"
                        }
                    }
                },
                {
                    field: "Name",
                    title: Helper.getTranslation("Statistik.IN_OVERVIEW_EVENTS.Resource"),
                    template: (item: GridItem) => {
                        let url = Config.baseUrl;
                        switch (item.Type) {
                            case this.PROJECT:
                                url += "Project/Edit?id="
                                break;
                            case this.SERVICE_REPORT:
                                url += "ServiceReport/Edit?id="
                                break;
                            case this.ASSIGNMENT:
                                url += "ResourcePlanning/EditByGuid?isguid="
                                break;
                        }
                        url += item.Pk;
                        return `<a class="truncate" title="${item.Name}" href="${url}" target="_blank">${item.Name}</a>`
                    }
                },
                {
                    field: "Amount",
                    title: Helper.getTranslation("Parts.ChargenSerien.Menge"),
                    template: (data: GridItem) => {
                        return amountTemplate(data.Amount)
                    },
                    groupFooterTemplate: (data) => {
                        let sum = this.calcSum(data);
                        return amountTemplate(sum, Helper.getTranslation("WebSMS.Warehouse.Subtotal"))
                    },
                    footerTemplate: () => {
                        let sum = 0;
                        this.props.data.forEach((item) => {
                            sum += item.Amount;
                        })
                        return amountTemplate(sum, Helper.getTranslation("Kapazitaet.Summe"))
                    }
                },
                {
                    field: "CreatedBy",
                    title: Helper.getTranslation("Field.Commdocuments.createuser")
                },
                {
                    field: "CreatedOnValue",
                    title: Helper.getTranslation("Dokument.CreatedOn"),
                    template: (data: GridItem) => {
                        const date = new Date(data.CreatedOn);
                        const newDate = new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000)

                        return kendo.toString(newDate, 'g');
                    },
                    groupHeaderTemplate: (data: KendoGroupingData) => {
                        return Helper.getTranslation("Dokument.CreatedOn") + ": " + kendo.toString(new Date(data.value), 'd');;
                    }
                }
            ]
        }
    }

    private calcSum = (data: {items: any[]}) => {
        let sum = 0;
        try {
            data.items.forEach((item) => {
                if (Helper.hasValue(item.Amount)) {
                    sum += item.Amount;
                } else {
                    sum += this.calcSum(item)
                }
            });
        } catch {}
        
        return sum;
    }

    render() {
        return (
            <div className="flex-container">
                <Grid
                    data={this.props.data}
                    options={this.gridOptions}
                    id={`stocks_usages`}
                />
            </div>
        )
    }
}

interface KendoGroupingData {
    value: number;
    items: GridItem[] | KendoGroupingData[]
}